import { useState } from 'react';
import { adminTemplateApi, type AdminTemplateRequest } from '../api/client';

/** Separate admin session: token stays in memory and is never sent to end-user routes. */
export function AdminTemplateRequestsPage(): JSX.Element {
  const [token, setToken] = useState('');
  const [requests, setRequests] = useState<AdminTemplateRequest[]>([]);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function load(): Promise<void> {
    if (!token.trim()) return;
    setBusy(true); setError('');
    try { setRequests(await adminTemplateApi.list(token.trim())); }
    catch (e) { setError((e as Error).message); }
    finally { setBusy(false); }
  }
  async function update(id: string, status: AdminTemplateRequest['status']): Promise<void> {
    setBusy(true); setError('');
    try {
      await adminTemplateApi.setStatus(token.trim(), id, status);
      setRequests((current) => current.map((item) => item.id === id ? { ...item, status } : item));
    } catch (e) { setError((e as Error).message); }
    finally { setBusy(false); }
  }

  return <main className="main"><div className="main-inner page">
    <div className="page-head"><h1>Template requests</h1><p>Paid requests from the studio app</p></div>
    <div className="card" style={{ padding: 24 }}>
      <label htmlFor="admin-token">Admin access token</label>
      <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
        <input id="admin-token" type="password" autoComplete="off" value={token}
          onChange={(event) => setToken(event.target.value)} placeholder="MFA admin token"
          style={{ flex: 1, minWidth: 0 }} />
        <button className="btn btn-primary" disabled={busy || !token.trim()} onClick={() => void load()}>Load requests</button>
      </div>
      <p style={{ marginTop: 8 }}>Use your separate admin token. It is kept only on this page.</p>
    </div>
    {error && <p role="alert">{error}</p>}
    {requests.map((item) => <div className="card" style={{ padding: 24 }} key={item.id}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}>
        <div><strong>Request {item.id}</strong><p>{new Date(item.createdAt).toLocaleString()}</p>
          {item.playOrderId && <p>Google Play order {item.playOrderId}</p>}</div>
        <select aria-label={`Status for ${item.id}`} value={item.status} disabled={busy}
          onChange={(event) => void update(item.id, event.target.value as AdminTemplateRequest['status'])}>
          <option value="new">New</option><option value="reviewing">Reviewing</option><option value="completed">Completed</option>
        </select>
      </div>
      <p style={{ whiteSpace: 'pre-wrap' }}>{item.description}</p>
      <small>Account {item.accountId}</small>
    </div>)}
    {!busy && token && requests.length === 0 && !error && <p>No requests yet.</p>}
  </div></main>;
}
